import axios from 'axios'

const API_URL = process.env.VUE_APP_API_URL;

class ElementiInListaService{

    async filterElementiInLista(token, lingua = "", tipo = ""){

        return axios({
            method: 'get',
            url: API_URL + 'elementiInLista/FilterElementiInLista', 
            params:{
                lingua: lingua,
                tipo: tipo
            },           
            headers:{
                    Authorization: 'Bearer '+ token,
                    'Content-Type': 'application/json'
            }
        }).then(data =>  {            
            if(data.status && data.status == 401){
                return false;
            }
            return data.data
        });

    }

}

export default new ElementiInListaService();